<!--
 * @Description:
 * @Author: Mankeung
 * @Date: 2021-07-15 14:13:14
 * @LastEditors: Mankeung
 * @LastEditTime: 2021-07-27 23:27:06
-->

<template>
  <section>
    <!-- <itemsDetail></itemsDetail> -->
    <el-page-header @back="goBack" :content="title"></el-page-header>
    <div class="topic-outer xq_common_text">
      <div
        class="appraisal-center fonts tab_info_casertyudsad"
        v-for="(item, index) in realItem"
        :key="index"
      >
        <div class="xq_common_textTitle">{{ emptyShow(item.con) }}</div>
        <div class="innner">
          <el-row v-if="item.index == 1">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>是否打包购买:</span> {{ detail2Data.isPackageGroup ? "是" : "否" }}
              </div>
            </el-col>
            <el-col :span="8" v-if="detail2Data.packageInfo">
              <div class="grid-content bg-purple">
                <span>二转已购方案:</span> {{ detail2Data.packageInfo.name }}
              </div>
            </el-col>
            <template v-if="detail2Data.order">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <span>订单编号:</span> {{ emptyShow(detail2Data.order.orderNumber) }}
                </div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <span>订单类型:</span> 
                  <span v-if="detail2Data.order.orderType=='PLANS_SKU'">订阅SKU</span>
                  <span v-else-if="detail2Data.order.orderType=='SKU_PACKAGE'">方案</span>
                  <span v-else>-</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <span>订单状态:</span>

                <span v-if="detail2Data.order.payStatus== 10" style="color: #409eff">支付成功</span>
                <span v-else>支付失败</span>

                </div>
              </el-col>
              <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付金额:</span>
                {{
                  emptyShow(detail2Data.order.orderMoney) ? `$ ${detail2Data.order.orderMoney / 100}` : ""
                }}
              </div>
            </el-col>
            
            </template>

            <template v-if="detail2Data.orderPays&&detail2Data.orderPays.length>0">
              <el-col :span="8">
                <div class="grid-content bg-purple">
                  <span>下单时间:</span>
                  {{ formatDate(detail2Data.orderPays[0].ctime||"",'YYYY-MM-DD HH:mm:ss') }}
                </div>
              </el-col>
            </template>
            <el-col :span="8" v-if="detail2Data.order.orderType=='PLANS_SKU'&&detail2Data.planSku">
                <div class="grid-content bg-purple">
                  <span>订阅SKU名称:</span>
                  {{ detail2Data.planSku.name||"-" }}
                </div>
              </el-col>
            <el-table
              :data="secondOrderSkuList"
              size="medium"
              border
              style="width: 100%"
              v-if="secondOrderSkuList&&secondOrderSkuList.length>0"
            >
              <el-table-column fixed prop="id" label="序号" type="index" width="50">
              </el-table-column>
              <el-table-column label="名称" prop="name" width="140"></el-table-column>
              <!-- <el-table-column
                label="国家/地区标识"
                prop="countryCode"
                width="150"
              ></el-table-column> -->
              <el-table-column label="价格" prop="orderMoney" width="100">
                <template slot-scope="scope">
                  $ {{ emptyShow(scope.row.orderMoney) / 100 }}
                </template>
              </el-table-column>
              <el-table-column label="权益" prop="payMoney">
                <template slot-scope="scope">
                  <span v-for="(item, index) in scope.row.skuList" :key="index">
                    {{ item.name }} 、
                  </span>
                </template>
              </el-table-column>
            </el-table>

          </el-row>
          <el-row v-if="item.index == 2">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单号:</span> {{ emptyShow(detailData.orderNumber) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>分类:</span> {{ emptyShow(detailData.categoryName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>名称:</span> {{ emptyShow(detailData.name) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>订单金额:</span>
                $ {{ emptyShow(detailData.payMoney) / 100 }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付方式:</span>
                {{ emptyShow(detailData.paymentTypeName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付状态:</span>
                <span style="color: #409eff">{{
                    emptyShow(detailData.payStatusName)
                  }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下单时间:</span>
                {{ emptyShow(detailData.ctime) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>完成时间:</span>
                {{ emptyShow(detailData.payTime) }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 3">
            <el-table
                :data="detailData.skus"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="50"
              >
              </el-table-column>
              <el-table-column
                  label="名称"
                  prop="name"
                  width="140"
              ></el-table-column>
              <el-table-column
                  label="国家/地区标识"
                  prop="countryCode"
                  width="150"
              ></el-table-column>
              <el-table-column label="价格" prop="payMoney" width="100">
                <template slot-scope="scope">
                  $ {{ emptyShow(scope.row.payPrice) / 100 }}
                </template>
              </el-table-column>
              <el-table-column label="权益" prop="payMoney" >
                <template slot-scope="scope">
                  <span v-for="(item,index) in scope.row.skuList" :key="index">
                    {{item.name}} 、
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-row>
          <el-row v-if="item.index == 4">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户昵称:</span> {{ emptyShow(detailData.nickName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>下单邮箱:</span> {{ emptyShow(detailData.email) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>设备标识:</span> {{ emptyShow(detailData.deviceId) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>性别:</span> {{ emptyShow(detailData.sexName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>年龄:</span> {{ emptyShow(detailData.age) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>国家标识:</span> {{ emptyShow(detailData.countryCode) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>语言标识:</span> {{ emptyShow(detailData.languageCode) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>用户IP:</span> {{ emptyShow(detailData.ip) }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 5">
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属应用:</span>
                <span>
                  {{ emptyShow(detailData.appInfoVo).appName }}
                </span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>归属渠道:</span>
                {{ emptyShow(detailData.channelAccountVo).name }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>支付商户:</span>
                {{ emptyShow(detailData.paymentMchVo).mchName }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>投放方式:</span> {{ emptyShow(detailData.putWayName) }}
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content bg-purple">
                <span>主体:</span>
                {{ emptyShow(detailData.channelMchVo).name }}
              </div>
            </el-col>
          </el-row>
          <el-row v-if="item.index == 6">
            <el-table
                :data="detailData.orderPayVos"
                size="medium"
                border
                style="width: 100%"
                v-loading="loading"
            >
              <el-table-column
                  fixed
                  prop="serviceId"
                  label="序号"
                  type="index"
                  width="50"
              >
              </el-table-column>
              <el-table-column
                  label="事件"
                  prop="payTypeName"
              ></el-table-column>
              <el-table-column
                  label="流水号"
                  prop="payCode"
                  min-width="230"
              ></el-table-column>
              <el-table-column label="支付金额" prop="payMoney">
                <template slot-scope="scope">
                  $ {{ emptyShow(scope.row.payMoney) / 100 }}
                </template>
              </el-table-column>
              <el-table-column label="支付方式" prop="paymentType" width="120">
              </el-table-column>
              <el-table-column
                  label="支付状态"
                  prop="payStatusName"
              ></el-table-column>
              <el-table-column label="归属商户" prop="mchName" width="180"></el-table-column>
              <el-table-column
                  label="创建时间"
                  prop="ctime"
                  min-width="160"
              ></el-table-column>
              <el-table-column
                  label="成功时间"
                  prop="finishTime"
                  min-width="160"
              ></el-table-column>
            </el-table>
          </el-row>
        </div>
      </div>
      <operation-confirmation
        @closeOperation="publicMethios"
        :operationVisible="operationVisible"
      ></operation-confirmation>
    </div>
  </section>
</template>

<script>
// import itemsDetail from "../layout/components/itemsDetail.vue";
import { formatDate } from "@/utils/filters/filter";
import { isEmpty, emptyShow } from "../../utils/tools/index";
import OperationConfirmation from "../../components/OperationConfirmation";
import {
  PAGE_SIZE,
} from "@/config";

export default {
  components: {
    // itemsDetail,
    OperationConfirmation,
  },
  data() {
    return {
      PAGE_SIZE,
      //分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      countList: 0,
      emptyShow,
      isEmpty,
      id: "",
      realItem: [], //展示信息模块
      title: "",
      detailData: [],
      detail2Data: {},
      loading: false,
      operationVisible: false,
      numType: false,
      tableData: [],
      secondOrderSkuList: [],
      formatDate,
    };
  },
  activated() {
    this.getOrgData();
  },
  created() {
    if (window.sessionStorage.getItem("operationKey")) {
      this.numType = true;
    }
    this.getOrgData();
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  watch: {
    $route(to, form) {
      if (to.query.value) {
        let toOrderNum = JSON.parse(to.query.value);
        let formOrderNum = JSON.parse(form.query.value);
        if (toOrderNum != formOrderNum) {
          this.getOrgData();
        }
      }
    },
  },
  methods: {
    //关闭
    publicMethios(e) {
      this.operationVisible = false;
      if (e == "open") {
        this.numType = true;
        setTimeout(() => {
          window.sessionStorage.removeItem("operationKey");
          this.numType = false;
        }, 1800000);
      }
    },
    //调起字组件的操作密码框
    operationShowTime(e) {
      this.operationVisible = true;
    },

    //订单详情
    getOrderDetail(row) {
      if (row.bizType == "vip") {
        this.$router.push({
          name: "ORDER_DETAIL",
          query: {
            id: 1,
            title: "会员订单",
            key: "orderNumber",
            value: JSON.stringify(row.orderNumber),
            path: "/vip/order/info",
          },
        });
      } else if (row.bizType == "exam") {
        this.$router.push({
          name: "ORDER_DETAIL",
          query: {
            id: 0,
            title: "测评订单",
            key: "orderNumber",
            value: JSON.stringify(row.orderNumber),
            path: "/exam/order/info",
          },
        });
      } else if (row.bizType == "pay") {
        this.$router.push({
        name: "SECOND_ORDER_DETAIL",
        query: {
          id: 2,
          title: "支付订单",
          key: "payCode",
          value0: JSON.stringify(row.examOrderNumber),
          value: JSON.stringify(row.orderNumber),
          path: `/secondPhase/order/info/${row.id}`,
        },
      });
        // this.$router.push({
        //   name: "ORDER_DETAIL",
        //   query: {
        //     id: 2,
        //     title: "支付订单",
        //     key: "payCode",
        //     value: JSON.stringify(row.orderNumber),
        //     path: "/pay/order/info",
        //   },
        // });
      } else if (
        row.bizType == "znqm" ||
        row.bizType == "zncm" ||
        row.bizType == "znys" ||
        row.bizType == "zwds" ||
        row.bizType == "znhp"
      ) {
        this.$router.push({
          name: "ORDER_DETAIL",
          query: {
            id: 4,
            title: "国学订单",
            key: "orderNumber",
            orderKey: "bizType",
            value: JSON.stringify(row.orderNumber),
            Typevalue: JSON.stringify(row.bizType),
            path: "/guoxue/order/info",
          },
        });
      } else if (row.bizType == "zncm") {
      } else if (row.bizType == "gsqm") {
      } else if (row.bizType == "taluo") {
        this.$router.push({
          name: "ORDER_DETAIL",
          query: {
            id: 5,
            title: "塔罗订单",
            key: "orderNumber",
            value: JSON.stringify(row.orderNumber),
            path: "/tarot/order/info",
          },
        });
      }
    },

    goDetails(e) {
      if (e.bizType == "vip") {
        this.$router.push({
          name: "ORDER_DETAIL",
          query: {
            id: 1,
            title: "会员订单",
            key: "orderNumber",
            value: JSON.stringify(e.orderNumber),
            path: "/vip/order/info",
          },
        });
      } else if (
        e.bizType == "znqm" ||
        e.bizType == "zncm" ||
        e.bizType == "znys" ||
        e.bizType == "zwds" ||
        e.bizType == "znhp"
      ) {
        this.$router.push({
          name: "ORDER_DETAIL",
          query: {
            id: 4,
            title: "国学订单",
            key: "orderNumber",
            orderKey: "bizType",
            value: JSON.stringify(e.orderNumber),
            Typevalue: JSON.stringify(e.bizType),
            path: "/guoxue/order/info",
          },
        });
      } else if (e.bizType == "taluo") {
        this.$router.push({
          name: "ORDER_DETAIL",
          query: {
            id: 5,
            title: "塔罗订单",
            key: "orderNumber",
            value: JSON.stringify(e.orderNumber),
            path: "/tarot/order/info",
          },
        });
      } else if (e.bizType == "exam") {
        this.$router.push({
          name: "ORDER_DETAIL",
          query: {
            id: 0,
            title: "测评订单",
            key: "orderNumber",
            value: JSON.stringify(e.orderNumber),
            path: "/exam/order/info",
          },
        });
      } else if (e.bizType == "pay") {
        
        this.$router.push({
          name: "SECOND_ORDER_DETAIL",
          query: {
            id: 2,
          title: "支付订单",
          key: "payCode",
          value0: JSON.stringify(e.examOrderNumber),
            value: JSON.stringify(e.orderNumber),
            path: `/secondPhase/order/info/${e.id}`,
            // id: 2,
            // title: "支付订单",
            // key: "payCode",
            // value: JSON.stringify(e.orderNumber),
            // path: "/pay/order/info",
          },
        });
      }
    },
    /* 返回上一页 */
    goBack() {
      this.$router.go(-1);
    },
    /* 接收参数并获取初始值 */
    async getOrgData() {
      this.id = this.$route.query.id;

      this.realItem = [
        { index: 1, con: "二转支付信息" },
        { index: 2, con: "支付信息" },
        { index: 3, con: "已购SKU信息" },
        { index: 4, con: "回调信息" },
        { index: 5, con: "用户信息" },
        { index: 6, con: "业务信息" },
      ];
      this.title = this.$route.query.title;

      // const { data: res } = await this.$get(
      //   `/exam/order/info?orderNumber=${JSON.parse(this.$route.query.value0)}`
      // );
      // if (res.data) this.detailData = res.data;
      // console.log(999999999,res,this.detailData)
      const { data: res2 } = await this.$get(`${this.$route.query.path}`);
      if (res2.data){
        this.detailData=res2.data.examOrder
        const childOrders = res2.data.childOrders||[];
        this.secondOrderSkuList = childOrders.map(item=>{
          const _order = item.order||{};
          return {
            ...item,
            ..._order,
 
            name:item.skuPackage?item.skuPackage.name:"-",
            title:item.skuPackage?item.skuPackage.title:"-",
            level:item.skuPackage?item.skuPackage.level:"-",
            originalPrice:item.skuPackage?item.skuPackage.originalPrice:"-",
            
          }
        });
        this.detail2Data = res2.data;
      } 

      if (this.$route.query.key == "userId") {
        this.getUserInfoOrder();
      }
    },

    async getUserInfoOrder() {
      this.loading = true;
      const { data: res } = await this.$get(
        "/kefu/user/order/list?pageNo=" +
          this.page.pageNo +
          "&pageSize=" +
          this.page.pageSize +
          "&userId=" +
          JSON.parse(this.$route.query.value)
      );
      this.loading = false;
      if (res.data) {
        this.tableData = res.data;
        this.countList = res.page.count;
      } else {
        this.tableData = [];
        this.countList = 0;
      }
    },

    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getUserInfoOrder();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getUserInfoOrder();
    },

    //tool hover框
    handleClose(index) {
      this.$refs[`popover-${index}`].doClose();
    },

    //reFund发起退款

    async tuikuanList(row) {
      let payCodes = row.payCode;
      let payCode = {
        payCode: payCodes,
      };
      this.$confirm("即将发起退款, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        this.$message.success("您的订单正在退款中，请稍后.");
        const { data: resData } = await this.$post("/order/refund/info", payCode);
        this.$message.success(resData.message);
        if (resData.result != 200) return;
        this.getOrgData();
      });
    },
    reFund(row) {
      let payCodes = row.payCode;
      let payCode = {
        payCode: payCodes,
      };
      this.$confirm("即将发起退款, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        this.$message.success("您的订单正在退款中，请稍后.");
        const { data: resData } = await this.$post("/order/refund/info", payCode);
        if (resData.result != 200) return;
        this.$message.success("退款成功!");
        this.getOrgData();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .el-table th,
::v-deep .el-table td {
  text-align: center !important;
}

::v-deep .el-page-header__content {
  font-size: 16px;
  color: #303133;
}

.topic-outer {
  width: 100%;
  overflow: hidden;
  margin-top: 10px;
  // padding-bottom: 30px;

  .el-row {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }

    .el-col {
      margin-bottom: 20px;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .appraisal-center {
    margin: 20px 0;
    border-radius: 6px;
    background: #fff;
    padding: 30px 20px;

    .innner {
      padding: 20px 20px 0;

      .grid-content {
        color: #888;

        span:first-child {
          color: #444;
          margin-right: 10px;
        }
      }
    }
  }
}
</style>

<style lang="scss">
//  箭头
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow {
  border-bottom-color: white !important;
}

// 箭头
.el-tooltip__popper[x-placement^="bottom"] .popper__arrow:after {
  border-bottom-color: white !important;
}

// 内容
.testtooltip {
  background: white !important;
  box-shadow: 1px 1px 10px 3px #d3d3d6;
}
</style>
